import { render } from "./LbrxQueueSummary.vue?vue&type=template&id=2316bfc5&scoped=true"
import script from "./LbrxQueueSummary.vue?vue&type=script&lang=js"
export * from "./LbrxQueueSummary.vue?vue&type=script&lang=js"

import "./LbrxQueueSummary.vue?vue&type=style&index=0&id=2316bfc5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2316bfc5"]])

export default __exports__